/* 函数命名规则
* rulesXxx      单条检验规格
* validatorXxx  自定义校验函数
* validatorFragmentXxx  自定义校验函数片段
* */
export function getRegExpPhone() {
  return /^1[3-9][0-9]{9}$/
}
export function rulesPhone(value) {
  console.log("9-----", value)
  return { pattern: getRegExpPhone(value), trigger: "blur",message: "手机号码格式有误（11位，13-19开头）"}
}

/**
 * 不能为空
 */
export function rulesNotEmpty(name=''){
  return {trigger: ['blur','change'],required:true,message:`${name+''}不能为空`, }
}

/**
 * 不能为空
 */
export function rulesNotFileInfo(res){
  return {pattern: !!res[0].filePath , trigger: ['blur','change'],message:`个人名片不能为空`, }
}

/**
 * 正数
 */
export function validatorFragmentIsPositiveNumber(rule, value, callback) {
  let num = parseFloat(value);
  if(num<=0) return callback(new Error('不能小于0'));
  return '';
}
/**
 * 浮点数
 */
export function validatorFragmentIsFloat(rule, value, callback) {
  let isFloat = /^-?[0-9]+(.[0-9]+)?$/ig.test(value);
  if(!isFloat) return callback(new Error('只支持数字(小数)'));
  return '';
}

/**
 * 整数
 */
export function validatorFragmentIsInteger(rule, value, callback) {
  let isFloat = /^-?[0-9]+$/ig.test(value);
  if(!isFloat) return callback(new Error('只支持整数'));
  return '';
}
/**
 * 正整数
 */
export function validatorFragmentIsPositiveInteger(rule, value, callback) {
  let judge = validatorFragmentIsInteger(...arguments);
  if(judge) return judge;
  let num = parseInt(value);
  if(num<1) return callback(new Error('不能小于1'));
  return '';
}

/**
 * 商品数量
 */
export function validatorGoodsQuantity(rule, value, callback) {
  let judge = validatorFragmentIsPositiveInteger(...arguments);
  if(judge) return judge;
  callback();
}
/**
 * 商品价格
 */
export function validatorGoodsPrice(rule, value, callback) {
  let judge = validatorFragmentIsFloat(...arguments);
  if(judge) return judge;
  judge = validatorFragmentIsPositiveNumber(...arguments);
  if(judge) return judge;
  callback();
}



/**
 * 获取element组件form表单的验证结果
 * @param form
 * @param filter // 是否只返回error信息
 * @returns {{validateMessage: *, label: *, validateState: *}[]}
 */
export function getElFormValidateValue(form,filter=true){
  // form = this.$refs[formName];
  let fields = form.fields;
  let list = fields.map(item=>{
    return {
      label:item.$props.label,
      state:item.$data.validateState,
      message:item.$data.validateMessage,
    };
  });
  if(filter) return list.filter(res=> res.state === 'error');
  return list;
}

/**
 * 打印表单验证错误结果
 * @param res
 */
export function notifyFormValidateErrorInfo(res) {
  this.$notify({
    title: '表单校验不通过',
    dangerouslyUseHTMLString: true,
    message: res.map(res=>`<p><span class="color-danger">${res.label}：</span>${res.message}</p>`).join(''),
    type: 'warning'
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/formRules.js